module.exports = __webpack_public_path__ + "static/media/42_A.ee6d8f4f.png";